export default __webpack_public_path__ + "static/assets/4f95145c890c2acc1f60ae898377f34c.png";